enum UrlSourceTypes {
  HOME_PAGE,
  SITEMAP,
  CATEGORY,
  CATEGORY_HUB,
  PRODUCT,
  PAGE,
  OTHER
}

export default UrlSourceTypes;
